/**
 * Transforms [[Card Name]] patterns in HTML content to placeholder spans
 * that can be hydrated with React CardLink components.
 */

/**
 * Escapes HTML special characters to prevent XSS
 */
function escapeHtml(text: string): string {
  const htmlEscapes: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  };
  return text.replace(/[&<>"']/g, (char) => htmlEscapes[char]);
}

/**
 * Transforms [[Card Name]] patterns in HTML to placeholder spans.
 *
 * @param html - The HTML content from TipTap editor
 * @returns HTML with [[Card Name]] patterns replaced with placeholder spans
 *
 * @example
 * transformCardLinks("Check out [[Lightning Bolt]] for burn decks")
 * // Returns: 'Check out <span class="card-link-placeholder" data-card-name="Lightning Bolt">Lightning Bolt</span> for burn decks'
 */
export function transformCardLinks(html: string): string {
  // Match [[Card Name]] patterns, capturing the card name inside
  // Handles special characters like apostrophes, hyphens, commas, colons, and slashes
  const regex = /\[\[([^\]]+)\]\]/g;

  return html.replace(regex, (match, cardName: string) => {
    const trimmedName = cardName.trim();

    // Skip empty card names
    if (!trimmedName) {
      return match;
    }

    const escapedName = escapeHtml(trimmedName);

    return `<span class="card-link-placeholder" data-card-name="${escapedName}">${escapedName}</span>`;
  });
}
